<template>
  <MuiForm
    v-model="formData"
    class="SignUpEmployeeStep2View Step__form"
    @submit.native="submit"
  >
    <h1 class="Step__title font-normal h1">
      {{ $t('Views.user_signup.step_2.title') }}
    </h1>
    <div class="Step__subtitle mb-4">
      {{ $t('Views.user_signup.step_2.subtitle') }}
    </div>
    <MuiSelect
      v-model="formModel.country"
      :label="$t('Views.user_signup.step_2.fields.country')"
      :placeholder="$t('Views.user_signup.step_2.fields.country_placeholder')"
      :disabled="isEmployee"
      :custom-error-messages="{
        empty: $t('Views.company_signup.errors.mandatory'),
      }"
      :on-change="(value) => $segments.trackSegment('Ubeeqo Country Selected', { country: value.code })"
      full-width
      name="country"
      object-label="name"
      object-value="code"
      required
      return-object
    >
      <MuiSelectItem
        v-for="country in countries"
        :key="country.code"
        :value="country"
      >
        {{ country.name }}
      </MuiSelectItem>
    </MuiSelect>
    <MuiButtonFlat
      :disabled="STATUS.LOADING"
      :is-loading="STATUS.LOADING"
      submit
      class="Step__form__next-button mb-4 cursor-pointer"
    >
      {{ $t('Views.user_signup.step_2.button') }}
    </MuiButtonFlat>
  </MuiForm>
</template>
<script>
import {
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';
import _ from 'lodash';

import {
  MuiForm,
  MuiButtonFlat,
  MuiSelect,
  MuiSelectItem,
} from '@ubeeqo/motion-ui';
import { GENERAL_MODULE, EMPLOYEE_MODULE } from '@/constants/modules';

import { steps } from '../constants';

export default {
  name: 'SignUpEmployeeStep2View',
  components: {
    MuiForm,
    MuiButtonFlat,
    MuiSelect,
    MuiSelectItem,
  },
  data() {
    return {
      formData: {},
    };
  },
  computed: {
    ...mapState(GENERAL_MODULE, {
      countries: state => state.countries,
    }),
    ...mapState(EMPLOYEE_MODULE, {
      currentCountry: state => state.info.country,
      isEmployee: state => state.b2b.invitation.valid_invite,
      done: state => state.done,
      STATUS: state => state.STATUS,
      b2b: state => state.b2b,
    }),
    formModel() {
      return {
        country: this.currentCountry,
      };
    },
  },
  async beforeMount() {
    if (this.done.step1 && this.b2b.invitation.valid_invite) {
      this.country({
        code: _.get(this, 'b2b.invitation.company.country_code'),
        default_cs_operator_uuid: _.get(this, 'b2b.invitation.company.cs_operator_uuid'),
      });
      await this.getDocuments();
      this.nextStep();
    }
  },
  mounted() {
    this.updateStep(steps.step2);

    if (!this.done.step1) {
      this.$router.push('./step1');
    }
  },
  methods: {
    ...mapMutations(EMPLOYEE_MODULE, [
      'doneStep',
      'updateStep',
      'country',
    ]),
    ...mapActions(EMPLOYEE_MODULE, [
      'getLegalDocuments',
    ]),
    async submit() {
      if (!this.formData.valid) return;

      await this.getDocuments();
      this.nextStep();
    },
    async getDocuments() {
      this.country({
        code: _.get(this, 'formModel.country.code'),
        default_cs_operator_uuid: _.get(this, 'formModel.country.default_cs_operator_uuid'),
      });
      await this.getLegalDocuments();
      if (this.STATUS.ERROR_LEGAL_DOCUMENTS) {
        this.createWarningNotification(this.$t('Views.user_signup.step_1.errors.mail_error'));
      }
    },
    nextStep() {
      this.doneStep(steps.step2);
      this.updateStep(steps.step3);
      this.$router.push('./step3');
    },
  },
};
</script>
